var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:[
  'timer',
  {
    expired: _vm.countdown < 0,
    neutral: _vm.countdown === null
  }
]},[_vm._v(" "+_vm._s(_vm.formatCountdown(_vm.countdown))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }